module.exports = __webpack_public_path__ + "static/media/stream_trooper_video_classes.992a4e14.svg";